import { dispatch } from 'store'
import { creditsThunks } from 'store/features/credits/thunks'
import { IUserCreditsSocketMessage } from 'types/userCredits'

export const handleUserCreditsSocketData = (
  data: IUserCreditsSocketMessage
) => {
  if (data.feature === 'ai') {
    dispatch(creditsThunks.setUserCredits(data.availableCredits))
  }
}
